/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lots_Col_Created_AtInputs */

const vi_sl_lots_col_created_at = /** @type {(inputs: Sl_Lots_Col_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

/**

* @param {Sl_Lots_Col_Created_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lots_col_created_at = /** @type {((inputs?: Sl_Lots_Col_Created_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lots_Col_Created_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lots_col_created_at(inputs)
});